import { createSelector } from 'reselect';

import { DEFAULT_LOCALE } from 'store/LanguageProvider/constants';

export const getLocale = (state: any) => state.getIn(['intl', 'locale']);

export const getLocaleSelector = createSelector(getLocale, (local) =>
  local ? local : DEFAULT_LOCALE,
);
